import * as React from 'react';
import createAxiosInstance from '../../../api';
import { useAlert } from '../../../components/Notification';
import { useSelector, useDispatch } from 'react-redux';
import {
  setEquipmentFilterInfoAction,
  setEquipmentCustomerDetailsAction,
  setInviteMemberAction,
  setEquipmentFilterAction,
  setPrimaryFieldsAction,
  setInvoiceListAction,
} from '../../../stores/actionTypes/equipmentInfoActions';

export function useHook() {
  const axiosInstance = createAxiosInstance();
  const showAlert = useAlert();
  const dispatch = useDispatch();

  const fetchGetEquipmentInfo = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/customers/getEquipments', payload)
      .then((response) => {
        dispatch(setEquipmentFilterInfoAction(response?.data?.data));
        data = response.data?.data;
      })
      .catch((error) => {
        dispatch(setEquipmentFilterInfoAction([]));
        showAlert('Failed get List Equipment', 'warning');
      });
    return data;
  };

  const fetchGetEquipmentDetails = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/customers/getEquipmentDetails', payload)
      .then((response) => {
        dispatch(setEquipmentCustomerDetailsAction(response?.data?.data));
        data = response.data?.data;
      })
      .catch((error) => {
        dispatch(setEquipmentCustomerDetailsAction({}));
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
    return data;
  };

  //   const fetchGetEquipmentFilter = async () => {
  //     await axiosInstance
  //       .get('/equipmentFilters')
  //       .then((response) => {
  //         dispatch(setEquipmentFilterAction(response?.data?.data));
  //       })
  //       .catch(() => {
  //         dispatch(setEquipmentFilterAction([]));
  //         showAlert('Failed get  Equipment Filter', 'warning');
  //       });
  //   };

  const fetchReadTimeSerieseParameter = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/customers/readTimeSerieseParameter', payload)
      .then((response) => {
        // dispatch(setEquipmentFilterInfoAction(response?.data?.data));
        data = response.data;
      })
      .catch((error) => {
        // dispatch(setEquipmentFilterInfoAction([]));
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
    return data;
  };

  const fetchReadUnitParameter = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/customers/readUnitParameter', payload)
      .then((response) => {
        data = response.data?.data;
      })
      .catch((error) => {
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
    return data;
  };

  const updateDeviceName = async (payload) => {
    let data = null;
    await axiosInstance
      .post('customers/updateDeviceName', payload)
      .then((response) => {
        fetchGetEquipmentDetails({ unitID: payload.unitID });
        showAlert('Device Name updated successfully', 'success');
        data = response;
      })
      .catch((error) => {
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
    return data;
  };

  const fetchAlertList = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/customers/getAlerts', payload)
      .then((response) => {
        data = response.data?.data;
      })
      .catch((error) => {
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
    return data;
  };

  const fetchWriteUnitParameterValue = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/customers/writeUnitParameterValue', payload)
      .then((response) => {
        data = response.data?.data;
      })
      .catch((error) => {
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
    return data;
  };

  const shareEquipment = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/customers/shareEquipment', payload)
      .then((response) => {
        showAlert('Shared Equipment Successfully', 'success');
        data = response?.data;
      })
      .catch((error) => {
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
    return data;
  };

  const updateshareEquipment = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/customers/shareEquipment', payload)
      .then((response) => {
        showAlert('User permission updated successfully', 'success');
        data = response?.data;
      })
      .catch((error) => {
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
    return data;
  };

  const updateWriteParameter = async (payload) => {
    let data = null;
    await axiosInstance
      .post('customers/updateWriteParameter', payload)
      .then((response) => {
        showAlert('Write Parameter updated successfully', 'success');
        data = response.data;
      })
      .catch((error) => {
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
    return data;
  };

  const fetchCustomerName = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/customers/getCustomerName', payload)
      .then((response) => {
        data = response.data?.data;
      })
      .catch((error) => {
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
    return data;
  };

  const fetchEquipmentShareList = async (payload) => {
    await axiosInstance
      .post('/customers/equipmentShareList', payload)
      .then((response) => {
        dispatch(setInviteMemberAction(response?.data?.data));
      })
      .catch((error) => {
        dispatch(setInviteMemberAction([]));
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
  };

  const deleteShareEquipment = async (payload) => {
    await axiosInstance
      .post('customers/removeShareEquipment', payload)
      .then((response) => {
        dispatch(setInviteMemberAction(response?.data?.data));
        showAlert(' ShareEquipment deleted successfully', 'success');
      })
      .catch((error) => {
        dispatch(setInviteMemberAction([]));
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
  };

  const fetchGetEquipmentFilter = async () => {
    await axiosInstance
      .get('/customers/getEquipmentsFilters')
      .then((response) => {
        dispatch(setEquipmentFilterAction(response?.data?.data));
      })
      .catch(() => {
        dispatch(setEquipmentFilterAction({}));
        showAlert('Failed get  Equipment Filter', 'warning');
      });
  };

  const fetchReadPrimaryParameter = async (payload) => {
    await axiosInstance
      .post('/customers/readPrimaryParameter', payload)
      .then((response) => {
        dispatch(setPrimaryFieldsAction(response?.data?.data));
      })
      .catch((error) => {
        dispatch(setPrimaryFieldsAction([]));
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
  };

  const upgradePlan = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/customers/upgradePlan', payload)
      .then((response) => {
        data = response.data?.data;
      })
      .catch((error) => {
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
    return data;
  };

  const fetchGetInvoiceList = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/customers/invoiceList', payload)
      .then((response) => {
        dispatch(setInvoiceListAction(response?.data?.data));
        data = response.data;
      })
      .catch((error) => {
        dispatch(setInvoiceListAction([]));
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
    return data;
  };
  return {
    fetchGetEquipmentInfo,
    fetchGetEquipmentDetails,
    fetchReadTimeSerieseParameter,
    fetchReadUnitParameter,
    updateDeviceName,
    fetchAlertList,
    shareEquipment,
    fetchWriteUnitParameterValue,
    updateWriteParameter,
    fetchCustomerName,
    fetchEquipmentShareList,
    deleteShareEquipment,
    updateshareEquipment,
    fetchGetEquipmentFilter,
    fetchReadPrimaryParameter,
    upgradePlan,
    fetchGetInvoiceList,
  };
}
